import * as actionTypes from 'actions';

const initialState = {
  open: false,
  type: '', // snackbar/401/confirmation
  typeProps: {}
};

const actionToType = {
  [actionTypes.OPEN_SNACKBAR]: 'snackbar',
  [actionTypes.OPEN_DIALOG401]: '401',
  [actionTypes.OPEN_TEXTAREA]: 'textarea',
  [actionTypes.OPEN_CONFIRMATION]: 'confirmation'
};

const alertReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actionTypes.OPEN_SNACKBAR:
    case actionTypes.OPEN_DIALOG401: 
    case actionTypes.OPEN_TEXTAREA: 
    case actionTypes.OPEN_CONFIRMATION: {
      const { payload } = action;
      return {
        open: true,
        type: actionToType[action.type],
        typeProps: {...payload}
      };
    }
    case actionTypes.CLOSE: {
      return {...initialState};
    }

    default: {
      return state;
    }
  }
};

export default alertReducer;
